! function(e) {
    if (e(document).ready((function() {

      //popin size guide
  $(".size-guide-trigger").click(function(e){
    e.preventDefault();
    $('.popUpBannerBox').show();
    var $modal = $('#size-guide-popup');
    $modal.addClass('open');
	});	 


//   $('.popUpBannerBox').click(function() {
//   	var $this = $(this);
//     $this.hide();
//   });
  
	$(".closePopUp").click(function(){
    	$(".popUpBannerBox").hide();
	});
  
  
    
  
    //show inches to cm unit
  
  $('.inches_btn').click(function() {
    var $this = $(this);
    $this.addClass('active').siblings().removeClass('active');
  	$('.inches_unit').removeClass('chartHide');
    $('.cm_unit').addClass('chartHide');
  });
    
   $('.cm_btn').click(function() {
    var $this = $(this);
    $this.addClass('active').siblings().removeClass('active');
    $('.cm_unit').removeClass('chartHide');
  	$('.inches_unit').addClass('chartHide');
    
  });
  
  
  //Load size chart on click category selection mens, womens, etc...
  $('#fitter-selection li').click(function() {
  	var $this = $(this);
    var selectedText = $this.text();
    var changeText = $('.currentDivision');
    var filterData = $this.attr("data-division");
    var catData = $('.size_chart_select_wrap[data-parent]');
    var parentData = $('.size_chart_select_wrap[data-parent="' + filterData + '"]');
    var dataText = parentData.attr("data-parent");
    var dataContainer = $('.size-charts[data-container]');
    var valueContainer = $('.size-charts[data-container="' + filterData + '"]');
    var containerText = valueContainer.attr("data-container");
    
    //replace category text to the selected text
    changeText.text(selectedText);
    //temporarily hide the size charts
    catData.hide();

    
   
//     if (filterData == containerText ) {
      //show size chart 
      valueContainer.show().siblings('.size-charts[data-container]').hide();
      //reload 2nd category
      parentData.show().siblings('.size_chart_select_wrap[data-parent]').hide();
      //show 2nd dropdown category
//       parentData.show();
//     }
    
  });    
  
  
  //Load size chart on click 2nd category selections tops, jeans, etc....
  $('li[data-content]').click(function() {
    var $this = $(this);
    var text = $this.text();
    var textAttr = $this.attr("data-content");
    var curText = $('.currentCategory').text(text);
    var containerChildren = $('.size_chart_data_wrap[data-children]')
    var catChildren = $('.size_chart_data_wrap[data-children="' + textAttr +'"]');
    var childrenAttr = catChildren.attr("data-children");
    
	console.log(childrenAttr);
    if ( textAttr == childrenAttr) {
      //show size chart
      catChildren.show().siblings().hide();
      
    }
  });
  
  
  $(document).on('click', '.size-guide-bg',function(e){
    console.log()
    $(e.target) == $('.popUpBannerBox');
    var $modal = $('#size-guide-popup');
    if($modal.hasClass('open')){
      $modal.removeClass('open').hide()
    }
  });
  if($('body').hasClass('template-product')){
      var productType = $('#productTypeContainer').val(),
          productTags = $('#producttags').val(),
          pcMen = (productTags.indexOf('BR Men') > -1),
          pcWomen = (productTags.indexOf('BR Women') > -1),
          ptTshirts = (productType.indexOf('Tshirts') > -1),
          ptPants = ((productType.indexOf('Jeans') > -1) || (productType.indexOf('Pants') > -1)),
          ptUnderwear = (productType.indexOf('Underwear') > -1),
          ptSweatshirts = (productType.indexOf('Sweatshirts') > -1),
          ptShoes = (productType.indexOf('Shoes') > -1),
          ptAccessories = (productType.indexOf('Accessories') > -1),
          ptDresses = (productType.indexOf('Dresses') > -1),
          ptOutwear = (productType.indexOf('Outerwear') > -1),
          ptExtra = (productType.indexOf('Extra') > -1),
      	  ptSkirts = (productType.indexOf('Skirts') > -1),
          ptDress = (productType.indexOf('Dresses') > -1),
          ptBlazers = (productType.indexOf('Blazers') > -1),
          ptOuterwear = (productType.indexOf('Outerwear') > -1),
          ptBlazersOuterwear = (productType.indexOf('Blazers & Outerwear') > -1),
          ptChino = (productType.indexOf('Chinos & Casual Pants') > -1),
          ptDpants = (productType.indexOf('Dress Pants') > -1),
          ptTees = (productType.indexOf('The Tee Shop') > -1),
          ptBlouses = (productType.indexOf('Blouses') > -1),
          ptDshirt = (productType.indexOf('Dress Shirts') > -1),
          ptSweaters = (productType.indexOf('Sweaters') > -1),
          ptPolo = (productType.indexOf('Polos') > -1),
          ptCjacket = (productType.indexOf('Coats & Jackets') > -1),
          ptBshirt = (productType.indexOf('Button-up Shirts') > -1),
          ptJumpsuits = (productType.indexOf('Jumpsuits') > -1)
      
             if($('body').hasClass('template-product')){
      if (pcMen) {
        $('#fitter-selection li[data-division="mens"]').trigger('click').trigger('click');
      } else {
        $('#fitter-selection li[data-division="womens"]').trigger('click').trigger('click');
      }

      if( (ptBshirt) || (ptCjacket) || (ptTshirts) || (ptSweatshirts) || (ptTees) || (ptBlouses) || (ptDshirt) || (ptSweaters) || (ptPolo) ){
        $('li[data-category="tops"]').trigger('click').trigger('click');
      }
      else if ( (ptPants) || (ptUnderwear) || (ptChino) || (ptDpants) ) {
        $('li[data-category="bottoms"]').trigger('click').trigger('click');
        $('li[data-category="denim"]').trigger('click').trigger('click');
      }

      else if (ptShoes) {
        $('li[data-category="shoes"]').trigger('click').trigger('click');
      }
      else if ( ptAccessories ) {
        $('li[data-category="accessories"]').trigger('click').trigger('click');
      }
      else if (ptSkirts) {
        $('li[data-category="skirts"]').trigger('click').trigger('click');
      }
      else if ( (ptDress) || (ptJumpsuits) ) {
        $('li[data-category="dresses"]').trigger('click').trigger('click');
      }
      else if ( (ptBlazers) || (ptOuterwear) || (ptBlazersOuterwear) ) {
        $('li[data-category="outerwear"]').trigger('click').trigger('click');
        $('li[data-category="blazers"]').trigger('click').trigger('click');
      }
    }

    $('.internalModal_absolute').click(function() {
      window.open('http://bananarepublic.us/', '_blank'); 
  //      var href = $('.hoverClick').attr('href');
  //      window.location.href = href;  
    });

  }

      
            e("#store-finder-slice-store-list .paged-list-inverted a").click((function(i) {
                i.preventDefault();
                var s = e(this);
                s.addClass("active").parent().siblings().children("a").removeClass("active");
                var t = s.attr("href");
                e('.store-details[data-store="' + t + '"]').css({
                    display: "flex"
                }).siblings(".store-details").hide()
            })), e("#promo-drawer").click((function() {
                var i = e(this),
                    s = i.find(".promodrawer-content"),
                    t = e("#black-overlay"),
                    r = i.find(".visib"),
                    o = i.find(".nvisib");
                r.removeClass("visib").addClass("nvisib"), o.removeClass("nvisib").addClass("visib"), s.hasClass("untoggled") ? (s.removeClass("untoggled"), t.removeClass("hidden")) : (s.addClass("untoggled"), t.addClass("hidden"))
            })), e("#promo-drawer-mob").click((function() {
                var i = e(this),
                    s = e("#black-overlay"),
                    t = i.find(".visib"),
                    r = i.find(".nvisib");
                t.removeClass("visib").addClass("nvisib"), r.removeClass("nvisib").addClass("visib"), s.toggleClass("hidden"), i.toggleClass("untoggled")
            })), e(".search-button-two").click((function() {
                var i = e(this).closest(".brand-bar-wrapper").find(".brand-search"),
                    s = e("#black-overlay2");
                i.addClass("search-active"), s.removeClass("hidden")
            })), e(".brand-search .close-btn").click((function(i) {
                i.preventDefault();
                var s = e(this);
                e("#black-overlay2").addClass("hidden"), s.closest(".brand-search").removeClass("search-active")
            })), e("#black-overlay2").click((function() {
                var i = e(this),
                    s = e("#brand-bar").find(".brand-search");
                i.addClass("hidden"), s.removeClass("search-active")
            })), e("#black-overlay").click((function() {
                var i = e(this),
                    s = e("#promo-drawer"),
                    t = e("#promo-drawer-mob"),
                    r = s.find(".promodrawer-content"),
                    o = s.find(".visib"),
                    a = s.find(".nvisib");
                o.removeClass("visib").addClass("nvisib"), a.removeClass("nvisib").addClass("visib"), i.addClass("hidden"), r.addClass("untoggled"), t.addClass("untoggled")
            })), e(".drop-btn").click((function() {
                var i = e(this),
                    s = i.find(".drop-icon"),
                    t = i.next();
                s.hasClass("off-drop") ? (s.removeClass("off-drop").text(s.text().replace("+", "-")), t.css("max-height", 800)) : (s.addClass("off-drop").text(s.text().replace("-", "+")), t.css("max-height", 0))
            })), e(".promoslide-main").slick({
                slidesToShow: 5,
                slidesToScroll: 3,
                prevArrow: e(".promo-slider .promo-prev"),
                nextArrow: e(".promo-slider .promo-next"),
                infinite: !1,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3.5,
                        prevArrow: !1,
                        nextArrow: !1,
                        swipeToSlide: !0
                    }
                }, {
                    breakpoint: 479,
                    settings: {
                        slidesToShow: 2.5,
                        prevArrow: !1,
                        nextArrow: !1
                    }
                }]
            }), e(".mkt-slider-wrapper .slideshow").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: e(".mkt-slider-wrapper .promo-prev.prev1"),
                nextArrow: e(".mkt-slider-wrapper .promo-next.next1"),
                infinite: !1,
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3.5,
                        prevArrow: !1,
                        nextArrow: !1,
                        swipeToSlide: !0
                    }
                }, {
                    breakpoint: 479,
                    settings: {
                        slidesToShow: 2.5,
                        slidesToScroll: 2
                    }
                }]
            }), e(".related-prod.for-slick .flex-container.for-upsells").slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow: e(".related-prod.for-slick .left-arrow"),
                nextArrow: e(".related-prod.for-slick .right-arrow"),
                infinite: !1,
                variableWidth: !1,
                responsive: [{
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 4
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3
                    }
                }]
            }), e(".related-prod.slick-mob .flex-container.for-upsells").slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                prevArrow: e(".related-prod.slick-mob .left-arrow"),
                nextArrow: e(".related-prod.slick-mob .right-arrow"),
                responsive: [{
                    breakpoint: 9999,
                    settings: "unslick"
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 4
                    }
                }]
            }), e(".related-prod.wwi-section .flex-container").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !0,
                mobileFirst: !0,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                }, {
                    breakpoint: 1024,
                    settings: "unslick"
                }]
            }), e(window).resize((function(i) {
                window.innerWidth < 1024 && e(".related-prod.wwi-section .flex-container").slick("refresh")
            })), e("html").click((function(i) {
                e(i.target).hasClass("hover-product") || e(i.target).hasClass("hover-mobile") || (e(".hover-product").removeClass("active"), e(".hover-mobile").removeClass("inactive"))
            })), e(".wwi-section .hover-mobile").click((function() {
                var i = e(this);
                i.addClass("inactive"), i.siblings(".hover-product").addClass("active")
            })), e(".homeProd_slider").each((function(i, s) {
                e(s).slick({
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    autoplay: !0,
                    autoplaySpeed: 4e3,
                    prevArrow: e(s).parent().find(".slide-prev"),
                    nextArrow: e(s).parent().find(".slide-next"),
                    infinite: !1,
                    responsive: [{
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    }]
                })
            })), e(".womenProd_listSlider").slick({
                slidesToShow: 4,
                slidesToScroll: 2,
                arrow: !0,
                prevArrow: e(".womenProd_leftArrow"),
                nextArrow: e(".womenProd_rightArrow"),
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2.5
                    }
                }, {
                    breakpoint: 375,
                    settings: {
                        slidesToShow: 4
                    }
                }, {
                    breakpoint: 345,
                    settings: {
                        slidesToShow: 4
                    }
                }]
            }), e(".ourstory-main-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: e(".ourstory-ArrowPrev.two"),
                nextArrow: e(".ourstory-ArrowNext.two"),
                variableWidth: !0,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: !0,
                        variableWidth: !1
                    }
                }]
            }), e(".mini-slider-content").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: e(".mini-slider .ourstory-ArrowPrev"),
                nextArrow: e(".mini-slider .ourstory-ArrowNext"),
                infinite: !0,
                autoplay: !0,
                autoplaySpeed: 3e3,
                pauseOnFocus: !1,
                pauseOnHover: !1
            }), e(".third-slick-jour").slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                prevArrow: e(".hpArrowPrev"),
                nextArrow: e(".hpArrowNext"),
                infinite: !0,
                autoplay: !1,
                speed: 1500,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: !0,
                        variableWidth: !1,
                        speed: 1e3
                    }
                }]
            }), e(".spring_mob_slider.the_tee_shop_women .slider-main").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: e(".spring_mob_slider.the_tee_shop_women .sps_left_arrow"),
                nextArrow: e(".spring_mob_slider.the_tee_shop_women .sps_right_arrow"),
                infinite: !0,
                autoplay: !1,
                speed: 500
            }), e(".filter-head .text-button").click((function() {
                var i = e(this),
                    s = i.parent().find(".facet-dropdown-container"),
                    t = i.parent().siblings();
                facetCous = t.find(".facet-dropdown-container"), i.parent().toggleClass("selected"), t.hasClass("selected") ? (t.removeClass("selected"), facetCous.not("hidden") && (facetCous.addClass("hidden"), s.removeClass("hidden"))) : (s.toggleClass("hidden"), e("#transparent-overlay").toggleClass("hidden"))
            })), e("#transparent-overlay").click((function() {
                var i = e(this),
                    s = i.siblings(".collections-main").find(".filter-head"),
                    t = i.siblings(".collections-main").find(".facet-dropdown-container");
                t.not("hidden") && s.hasClass("selected") && (t.addClass("hidden"), s.removeClass("selected"), i.addClass("hidden"))
            })), e(".matrix-head").click((function() {
                var i = e(this),
                    s = i.data("matrix");
                groupList = i.parent().siblings(".group-list." + s), parentGroup = i.parent().siblings(), parentGroup.hasClass("size-container") && (groupList = i.parent().siblings(".size-container").find(".group-list." + s), groupList.hasClass(s) && groupList.addClass("active").siblings().removeClass("active")), i.not("selected") && (i.addClass("selected").siblings().removeClass("selected"), groupList.hasClass(s) && groupList.addClass("active").siblings().removeClass("active"))
            })), e(".header-button").click((function() {
                var i, s, t = e(this),
                    r = (t.parent(), e(".info-sidepanel")),
                    o = t.data("label"),
                    a = e('.info-sidepanel-btn[data-label="'.concat(o, '"]')),
                    n = e('.info-sidepanel-rte[data-label="'.concat(o, '"]')),
                    l = e(".main-product-info").offset();
                if (e(window).width() > 1024) {
                    r.addClass("active"), a.addClass("active").siblings().removeClass("active"), n.addClass("active").siblings().removeClass("active");
                    var d = l;
                    d.top = d.top, d.right = d.right, i = d.top, s = d.left, e("html, body").animate({
                        scrollTop: i,
                        scrollRight: s
                    })
                }
            })), e(".info-sidepanel-close-btn").click((function() {
                e(this).closest(".info-sidepanel.active").removeClass("active")
            })), e(".info-sidepanel-btn").click((function() {
                var i = e(this),
                    s = i.data("label"),
                    t = i.closest(".info-sidepanel-inner").find('.info-sidepanel-rte[data-label="'.concat(s, '"]')),
                    r = e(window).width();
                i.addClass("active").siblings().removeClass("active"), r > 1024 && t.addClass("active").siblings().removeClass("active")
            }));
            var i = e(".info-sidepanel-content.mob");

            function s() {
                e(".sr-details-main").fadeToggle((function() {
                    e("html, body").toggleClass("scroll-hidden")
                }))
            }
            i.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: !1,
                mobileFirst: !0,
                arrows: !1,
                responsive: [{
                    breakpoint: 1024,
                    settings: "unslick"
                }]
            }), e(".info-sidepanel.mob .info-sidepanel-btn").click((function() {
                var s = e(this).index();
                i.slick("slickGoTo", s)
            })), e(".sr-overlay-bg").click((function() {
                s()
            })), e(".sr-header button").click((function() {
                s()
            })), e(".sr-btn button").click((function() {
                s()
            })), i.on("beforeChange", (function(i, s, t, r) {
                e(".info-sidepanel.mob .info-sidepanel-btn").eq(r).addClass("active").siblings().removeClass("active")
            })), i.on("afterChange", (function(e, i, s, t) {
                var r = i.slideCount - 1;
                i.options.swipe = s !== r
            })), e(".universal-right .account-button").click((function(i) {
                var s = e(this),
                    t = s.siblings(".account-dropdown");
                s.toggleClass("active"), t.toggleClass("active")
            })), e(document).mouseup((function(i) {
                var s = e(".universal-right .account-button"),
                    t = s.siblings(".account-dropdown");
                s.is(i.target) || 0 !== s.has(i.target).length || t.is(i.target) || 0 !== t.has(i.target).length || (s.removeClass("active"), t.removeClass("active"))
            })), e("#qty-button").click((function() {
                var i = e(this),
                    s = i.siblings(".quantity-select");
                i.toggleClass("active"), s.toggle("slide")
            })), e(".item-qty .quantity-selector.unique-class").change((function() {
                var i = e(this),
                    s = i.children("option:selected").val();
                i.closest(".qty-price-section").siblings(".product-details").find(".cart__qty-input.qty-data").val(s), i.siblings(".update-action").trigger("click")
            })), e("#bc-sf-filter-tree-h").ready((function(i) {
                e(this).addClass("it-works")
            })), e("#bc-sf-filter-tree-h").children().ready((function(i) {
                var s = e(this);
                s.parent(), s.hasClass("bc-sf-filter-selection-wrapper") ? s.addClass("it-works") : s.addClass("it-kinda-works")
            })), e("#bc-sf-filter-tree-mobile").delegate("button", "click", (function() {
                e(this), e("#black-overlay3").fadeIn(500)
            })), e("#black-overlay3").click((function() {
                var i = e(this);
                e("#bc-sf-filter-tree").slideToggle(500), i.fadeOut(500)
            })), e("#bc-sf-filter-tree-h").delegate(".bc-sf-filter-block-content-inner ul li a", "click", (function(i) {
                i.preventDefault(), e(this).closest('ul[class*="bc-sf-filter-option"]').siblings(".bc-sf-filter-select-button").trigger("click")
            })), e(".special-dropdown-mob .header.button-drop").click((function() {
                e(this).siblings(".shop-more-lists").toggleClass("drop-off")
            })), e("#detail-link").click((function(i) {
                i.preventDefault(), e(".modal-overlay").show()
            })), e(".modal-close-button").click((function() {
                e(".modal-overlay").hide()
            }))
        })), e(window).resize((function() {
            e("#brand-bar").find(".brand-search").removeClass("\tsearch-active"), e("#black-overlay2").addClass("hidden")
        })), e("#addANewAddress").click((function(i) {
            i.stopPropagation(), i.preventDefault(), e("#AddressBook").slideUp(), e("#newAddressForm").slideDown()
        })), e(".addresspage #cancelButton").click((function(i) {
            i.preventDefault(), e("#AddressBook").slideDown(), e("#newAddressForm").slideUp()
        })), e(".addresspage #saveAndAddButton").click((function(i) {
            i.preventDefault(), e(this).closest("form").trigger("submit")
        })), 
        
        
        e(".size-guide-trigger").click((function(i) {
            i.preventDefault(), e(window).width() < 1024 && (e(".popUpBannerBox").show(), e("#size-guide-popup").addClass("open"))
        })), e(".closePopUp").click((function() {
            e(".popUpBannerBox").hide()
        })), e(".g-lg-1-2").click((function() {
            e(this).toggleClass("active").siblings(".size_chart_select_wrap[data-parent]").removeClass("active")
        })), e(".size_chart_select_wrap[data-parent]").click((function() {
            e(this).toggleClass("active")
        })), e(".inches_btn").click((function() {
            e(this).addClass("active").siblings().removeClass("active"), e(".inches_unit").removeClass("chartHide"), e(".cm_unit").addClass("chartHide")
        })), e(".cm_btn").click((function() {
            e(this).addClass("active").siblings().removeClass("active"), e(".cm_unit").removeClass("chartHide"), e(".inches_unit").addClass("chartHide")
        })), e("#fitter-selection li").click((function() {
            var i = e(this),
                s = i.text(),
                t = e(".currentDivision"),
                r = i.attr("data-division"),
                o = e(".size_chart_select_wrap[data-parent]"),
                a = e('.size_chart_select_wrap[data-parent="' + r + '"]'),
                n = (a.attr("data-parent"), e(".size-charts[data-container]"), e('.size-charts[data-container="' + r + '"]'));
            n.attr("data-container"), t.text(s), o.hide(), n.show().siblings(".size-charts[data-container]").hide(), a.show().siblings(".size_chart_select_wrap[data-parent]").hide()
        })), e("li[data-content]").click((function() {
            var i = e(this),
                s = i.text(),
                t = i.attr("data-content");
            i.closest(".sizechartCategorySelector").find(".currentCategory").text(s), e(".size_chart_data_wrap[data-children]");
            var r = e('.size_chart_data_wrap[data-children="' + t + '"]');
            t == r.attr("data-children") && r.show().siblings().hide()
        })), e(".ui-accordion-header").click((function() {
            var i = e(this),
                s = i.attr("id");
            i.toggleClass("ui-state-active"), setTimeout((function() {
                i.siblings('.ui-accordion-content[aria-labelledby="' + s + '"]').slideToggle()
            }), 300), i.children(".ui-accordion-header-icon").toggleClass("icon-minus").toggleClass("icon-plus")
        })), e(document).on("click", ".size-guide-bg", (function(i) {
            e(i.target), e(".popUpBannerBox");
            var s = e("#size-guide-popup");
            s.hasClass("open") && s.removeClass("open").hide()
        })), e("body").hasClass("template-product")) {
        var i = e("#productTypeContainer").val(),
            s = e("#producttags").val(),
            t = s.indexOf("BR Men") > -1 || s.indexOf("BR MEN") > -1,
            r = (s.indexOf("BR Women") > -1 || s.indexOf("BR WOMEN"), i.indexOf("Tshirts") > -1),
            o = i.indexOf("Jeans") > -1 || i.indexOf("Pants") > -1 || i.indexOf("Denim") > -1,
            a = i.indexOf("Underwear") > -1 || s.indexOf("Underwear") > -1,
            n = i.indexOf("Sweatshirts") > -1,
            l = i.indexOf("Shoes") > -1 || s.indexOf("Shoes") > -1,
            d = i.indexOf("Accessories") > -1 || s.indexOf("Accessories") > -1,
            c = (i.indexOf("Dresses") > -1 || s.indexOf("Dresses"), i.indexOf("Outerwear"), i.indexOf("Extra"), i.indexOf("Skirts") > -1),
            p = i.indexOf("Dresses") > -1,
            g = i.indexOf("Blazers") > -1,
            h = i.indexOf("Outerwear") > -1,
            f = i.indexOf("Blazers & Outerwear") > -1,
            v = i.indexOf("Chinos & Casual Pants") > -1,
            u = i.indexOf("Dress Pants") > -1,
            b = i.indexOf("The Tee Shop") > -1,
            w = i.indexOf("Blouses") > -1,
            k = i.indexOf("Dress Shirts") > -1,
            m = i.indexOf("Sweaters") > -1,
            C = i.indexOf("Polos") > -1,
            x = i.indexOf("Coats & Jackets") > -1 || s.indexOf("Coats & Jackets") > -1,
            S = i.indexOf("Button-up Shirts") > -1,
            y = i.indexOf("Jumpsuits") > -1,
            T = i.indexOf("Shorts") > -1;
        e("body").hasClass("template-product") && (t ? e('#fitter-selection li[data-division="mens"]').trigger("click").trigger("click") : e('#fitter-selection li[data-division="womens"]').trigger("click").trigger("click"), S || r || n || b || w || k || m || C ? t ? e('.sizechartCategorySelector.men li[data-category="tops"]').trigger("click").trigger("click") : e('.sizechartCategorySelector.women li[data-category="tops"]').trigger("click").trigger("click") : o || a || v || u || T ? (e('li[data-category="bottoms"]').trigger("click").trigger("click"), e('li[data-category="denim"]').trigger("click").trigger("click")) : l ? e('li[data-category="shoes"]').trigger("click").trigger("click") : d ? e('li[data-category="accessories"]').trigger("click").trigger("click") : c ? e('li[data-category="skirts"]').trigger("click").trigger("click") : p || y ? e('li[data-category="dresses"]').trigger("click").trigger("click") : (g || x || h || f) && (x ? e('li[data-category="outerwear"]').trigger("click").trigger("click") : e('li[data-category="blazers"]').trigger("click").trigger("click"))), e(".internalModal_absolute").click((function() {
            window.open("http://bananarepublic.us/", "_blank")
        }))
    }

        

  
}(jQuery);